import LoginSso from "./thirdpart/LoginSso";

/**
 * 进登录页时是否直接跳转第三方登录
 *
 * @type {boolean}
 */
const straightThirdPartLogin = true;

/**
 * 直接跳转第三方登录的地址
 *
 * @type {string}
 */
const defaultThirdPartLoginUrl = LoginSso.getLoginUrl;

/**
 * 三方登录回调地址时，返回userType的key的值
 * 用于判断三方登录的类型
 *
 * @type {string[]}
 */
const userTypeKeys = [
  LoginSso.getUserTypeKey()
];

const loginThirdPartMap = {
  [LoginSso.userType]: LoginSso
};

export default {
  straightThirdPartLogin,
  defaultThirdPartLoginUrl,
  userTypeKeys,
  loginThirdPartMap
}
